import IconTooltip from './IconTooltip';
import SystemIconModifier, { type SystemIconProps } from './SystemIcon';

function MultiSelect(props: SystemIconProps) {
  const { isSystem } = props;
  return (
    <IconTooltip isSystem={isSystem}>
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium fs-exclude"
        focusable="false"
        aria-hidden="true"
        data-testid="MultiSelectIcon"
        data-dd-action-name="FIM 3 Custom Field - icon redacted"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="28" height="28" rx="4" fill="#CDC1E5" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6667 6.5H7.33341C6.41675 6.5 5.66675 7.25 5.66675 8.16667V19.8333C5.66675 20.75 6.41675 21.5 7.33341 21.5H20.6667C21.5834 21.5 22.3334 20.75 22.3334 19.8333V8.16667C22.3334 7.25 21.5834 6.5 20.6667 6.5ZM20.6667 19.8333H7.33341V8.16667H20.6667V19.8333Z"
          fill="#6B5499"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.175 12.6833L18.9917 11.5L16.35 14.1417L15.175 12.9583L14 14.1333L16.35 16.5L20.175 12.6833Z"
          fill="#6B5499"
        />
        <path d="M12.3334 9.83301H8.16675V11.4997H12.3334V9.83301Z" fill="#6B5499" />
        <path d="M12.3334 13.167H8.16675V14.8337H12.3334V13.167Z" fill="#6B5499" />
        <path d="M12.3334 16.5H8.16675V18.1667H12.3334V16.5Z" fill="#6B5499" />
        {isSystem && SystemIconModifier()}
      </svg>
    </IconTooltip>
  );
}

export default MultiSelect;
